module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_07_Wheel.79c36fae.png";